import {
  ArrowDropDown as ArrowDropDownIcon,
  Inventory2Outlined as ProductsIcon,
  SellOutlined as BrandsIcon,
} from "@mui/icons-material";
import { Button } from "@mui/material";
import { MenuButton, MenuItemWithIcon, ModalOpenButton } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { PickBrandPreferencesModal } from "../modals/PickBrandPreferencesModal.js";

type PickBrandPreferencesProps = Omit<
  React.ComponentProps<typeof PickBrandPreferencesModal>,
  "handleClose"
>;

interface Props {
  /** Opens the catalogue assignment search; `null` where articles cannot be added. */
  onAssignProducts: (() => void) | null;
  /** The brand picker; `null` where brands cannot be added. */
  brandPicker: PickBrandPreferencesProps | null;
  disabled: boolean;
}

/**
 * The single entry point for adding preferences. With both kinds available it offers them in
 * a menu; with one it opens that one directly, so the Global entry adds brands in one click.
 */
export function AddPreferenceButton({
  onAssignProducts,
  brandPicker,
  disabled,
}: Props) {
  const { t } = useTranslate(["Product"]);
  const label = t("Add preference", { ns: "Product" });

  if (onAssignProducts !== null && brandPicker !== null) {
    return (
      <MenuButton
        Button={
          <Button
            variant="contained"
            color="primary"
            size="small"
            endIcon={<ArrowDropDownIcon />}
            disabled={disabled}
          >
            {label}
          </Button>
        }
      >
        <MenuItemWithIcon icon={<ProductsIcon />} onClick={onAssignProducts}>
          {t("Products from the catalogue", { ns: "Product" })}
        </MenuItemWithIcon>
        <ModalOpenButton
          Modal={PickBrandPreferencesModal}
          modalProps={brandPicker}
        >
          <MenuItemWithIcon icon={<BrandsIcon />}>
            {t("Brands", { ns: "Product" })}
          </MenuItemWithIcon>
        </ModalOpenButton>
      </MenuButton>
    );
  }

  const button = (
    <Button
      variant="contained"
      color="primary"
      size="small"
      disabled={disabled}
      onClick={onAssignProducts ?? undefined}
    >
      {label}
    </Button>
  );

  if (brandPicker !== null)
    return (
      <ModalOpenButton
        Modal={PickBrandPreferencesModal}
        modalProps={brandPicker}
      >
        {button}
      </ModalOpenButton>
    );
  if (onAssignProducts !== null) return button;
  return null;
}
